import { ApiFormattedResponse } from "@models/api_formatted_response"
import {
  CreateCollageTemplateSetData,
  CreateCollageTemplateSetInput
} from "@models/collage"
import { mutate } from "@utils/graphql"
import createCollageTemplateSet from "__generated__/queries/mutations/createCollageTemplateSet"

type Envelope<T> = {
  success?: boolean
  data?: T
  code?: string
  message?: string
}

export async function createCollageTemplateSetReq(
  input: CreateCollageTemplateSetInput
): Promise<ApiFormattedResponse<CreateCollageTemplateSetData>> {
  const response = await mutate<{
    createCollageTemplateSet?: Envelope<CreateCollageTemplateSetData>
  }>({ mutation: createCollageTemplateSet, variables: { input } })

  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }

  return {
    isSuccess: true,
    data: response?.data?.createCollageTemplateSet?.data
  }
}
